import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(({ typography, breakpoints }) => ({
  backgroundTheme: {
    backgroundColor: '#F9F9F9',
    padding: '70px 0',
  },
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '0 auto',
    maxWidth: '1200px',
  },
  answer: {
    fontSize: typography.pxToRem(18),
    fontWeight: typography.fontWeightRegular,
  },
  answerCarrefour: {
    fontFamily: 'Milliard Book',
  },
  answerReparofone: {
    fontFamily: 'Roboto',
  },
  heading: {
    fontSize: typography.pxToRem(20),
    fontWeight: typography.fontWeightBold,
  },
  headingCarrefour: {
    fontFamily: 'Milliard Book',
  },
  headingReparofone: {
    fontFamily: 'Roboto',
  },
  accordion: {
    width: '100%',
  },
  title: {
    fontSize: '3em',
    fontWeight: 100,
    padding: '0 40px',
    marginBottom: '30px',
    [breakpoints.down('xs')]: {
      fontSize: '2em',
      textAlign: 'center',
      padding: '0 50px',
    },
  },
  titleCarrefour: {
    fontFamily: 'Milliard Book',
  },
  titleReparofone: {
    fontFamily: 'Roboto',
  },
}));

export default styles;
